import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button';
import GlobalOptInDefaultImageBanner from '../../assets/global-opt-in-default-image-banner.svg';
import { messages } from '../../messages';
import { BodyWrapper, ButtonContainer, ContentContainer, HeaderWrapper, ImageWrapper, LearnMoreWrapper, OptInBackgroundBorder, OptInContainer, OrgAdminDefaultBodyWrapper } from './styled';
const DEFAULT_GAS_CHANNEL = 'fabric-elements';
const AiOptIn = ({
  source,
  product,
  isOrgAdmin,
  image,
  headerText,
  bodyText,
  width,
  testId,
  onAdminCTA,
  onAdminClose,
  adminBodyText,
  adminHeaderText,
  adminCTAText,
  adminCloseCTAText,
  adminLink
}) => {
  const {
    formatMessage
  } = useIntl();
  const {
    createAnalyticsEvent
  } = useAnalyticsEvents();
  const defaultHeader = formatMessage(messages.aiOptInDialogHeaderText);
  const header = headerText !== null && headerText !== void 0 ? headerText : defaultHeader;
  const body = bodyText !== null && bodyText !== void 0 ? bodyText : formatMessage(messages.aiOptInDialogBodyText);
  const orgAdminBody = formatMessage(messages.aiOptInDialogAdminBodyText);
  const orgAdminHeader = adminHeaderText !== null && adminHeaderText !== void 0 ? adminHeaderText : defaultHeader;
  const WAC_LINK = 'https://www.atlassian.com/trust/atlassian-intelligence';
  const ADMIN_LINK = 'http://admin.atlassian.com/';
  useEffect(() => {
    const preloadImages = paths => {
      paths.forEach(path => {
        const img = new Image();
        img.src = path;
      });
    };
    preloadImages([GlobalOptInDefaultImageBanner]);
  }, []);
  useEffect(() => {
    createAnalyticsEvent({
      type: 'sendScreenEvent',
      data: {
        name: 'aiGlobalOptInDialog',
        attributes: {
          source,
          product,
          isOrgAdmin: !!isOrgAdmin
        }
      }
    }).fire(DEFAULT_GAS_CHANNEL);
  }, [createAnalyticsEvent, source, product, isOrgAdmin]);
  const onLearnMoreClicked = e => {
    e.stopPropagation();
    createAnalyticsEvent({
      type: 'sendUIEvent',
      data: {
        source,
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'aiGlobalOptInDialogLearnMoreLink',
        attributes: {
          product,
          isOrgAdmin: !!isOrgAdmin
        }
      }
    }).fire(DEFAULT_GAS_CHANNEL);
  };
  const onCloseClicked = e => {
    e.stopPropagation();
    onAdminClose === null || onAdminClose === void 0 ? void 0 : onAdminClose();
    createAnalyticsEvent({
      type: 'sendUIEvent',
      data: {
        source,
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'aiGlobalOptInDialogAdminCloseButton',
        attributes: {
          product
        }
      }
    }).fire(DEFAULT_GAS_CHANNEL);
  };
  const onCTAClicked = e => {
    e.stopPropagation();
    onAdminCTA === null || onAdminCTA === void 0 ? void 0 : onAdminCTA();
    createAnalyticsEvent({
      type: 'sendUIEvent',
      data: {
        source,
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'aiGlobalOptInDialogAdminCTAButton',
        attributes: {
          product
        }
      }
    }).fire(DEFAULT_GAS_CHANNEL);
  };
  const getAdminBody = () => {
    return adminBodyText !== null && adminBodyText !== void 0 ? adminBodyText : /*#__PURE__*/React.createElement(React.Fragment, null, orgAdminBody, /*#__PURE__*/React.createElement(OrgAdminDefaultBodyWrapper, null, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.aiOptInDialogAdminTurnOnText, {
      values: {
        a: s => /*#__PURE__*/React.createElement("a", {
          href: WAC_LINK,
          target: "_blank",
          onClick: onLearnMoreClicked
        }, s)
      }
    }))));
  };
  return /*#__PURE__*/React.createElement(OptInBackgroundBorder, {
    width: width,
    "data-testid": testId
  }, /*#__PURE__*/React.createElement(OptInContainer, null, image ? /*#__PURE__*/React.createElement(ImageWrapper, null, image) : /*#__PURE__*/React.createElement(ImageWrapper, null, /*#__PURE__*/React.createElement("img", {
    src: GlobalOptInDefaultImageBanner,
    height: "96px"
  })), /*#__PURE__*/React.createElement(ContentContainer, null, /*#__PURE__*/React.createElement(HeaderWrapper, null, isOrgAdmin ? orgAdminHeader : header), /*#__PURE__*/React.createElement(BodyWrapper, null, isOrgAdmin ? getAdminBody() : body), !isOrgAdmin && /*#__PURE__*/React.createElement(Button, {
    appearance: "link",
    spacing: "none",
    href: WAC_LINK,
    target: "_blank",
    onClick: onLearnMoreClicked
  }, /*#__PURE__*/React.createElement(LearnMoreWrapper, null, formatMessage(messages.aiOptInDialogLearnMoreLinkText))), isOrgAdmin && /*#__PURE__*/React.createElement(ButtonContainer, null, /*#__PURE__*/React.createElement(Button, {
    appearance: "subtle",
    onClick: onCloseClicked,
    testId: "admin-close-button"
  }, adminCloseCTAText !== null && adminCloseCTAText !== void 0 ? adminCloseCTAText : formatMessage(messages.aiOptInDialogAdminCloseButtonText)), /*#__PURE__*/React.createElement(Button, {
    appearance: "primary",
    onClick: onCTAClicked,
    href: adminLink !== null && adminLink !== void 0 ? adminLink : ADMIN_LINK,
    target: "_blank",
    testId: "admin-cta-button"
  }, adminCTAText !== null && adminCTAText !== void 0 ? adminCTAText : formatMessage(messages.aiOptInDialogAdminLetsGoButtonText))))));
};
export default AiOptIn;